import React from 'react'

export const HeaderInterior = () => (
  <header className='header' role='banner'>
    <div className='container'>
      <p>This is the interior header.</p>
    </div>
  </header>
)
